import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Truck, Clock, Gift } from "lucide-react";

export default function ShippingSection() {
    const [zones, setZones] = useState([]);

    useEffect(() => {
        api.get("/shipping-zones")
            .then((r) => setZones(r.data))
            .catch(() => setZones([]));
    }, []);

    if (zones.length === 0) return null;

    function formatPrice(n) {
        if (n === 0) return "Gratis";
        return `$${n.toLocaleString("es-CO")}`;
    }

    return (
        <section className="px-6 md:px-12 lg:px-20 py-16 lg:py-24 bg-blush/40" data-testid="shipping-section">
            <div className="text-center mb-12">
                <Truck strokeWidth={1.5} className="w-7 h-7 text-gold mx-auto" />
                <p className="overline mt-3">Envíos</p>
                <h2 className="font-serif text-4xl sm:text-5xl text-charcoal mt-3">
                    Llegamos a <span className="italic">ti.</span>
                </h2>
            </div>
            <div className="max-w-4xl mx-auto bg-white rounded-2xl border border-border-soft overflow-hidden shadow-sm">
                <div className="grid grid-cols-12 gap-4 px-6 py-4 bg-blush text-taupe text-xs tracking-[0.2em] uppercase">
                    <div className="col-span-5">Zona</div>
                    <div className="col-span-2 text-right">Costo</div>
                    <div className="col-span-3 text-right md:text-center">Tiempo</div>
                    <div className="col-span-2 text-right">Envío gratis</div>
                </div>
                {zones.map((z) => (
                    <div
                        key={z.id}
                        className="grid grid-cols-12 gap-4 px-6 py-5 border-t border-border-soft items-center"
                        data-testid={`shipping-zone-${z.id}`}
                    >
                        <div className="col-span-5 font-serif text-xl text-charcoal">{z.name}</div>
                        <div className="col-span-2 text-right font-semibold text-gold">{formatPrice(z.cost)}</div>
                        <div className="col-span-3 text-right md:text-center text-sm text-taupe flex md:justify-center items-center gap-1">
                            <Clock strokeWidth={1.5} className="w-3 h-3 hidden md:inline" />
                            <span>{z.delivery_time || "—"}</span>
                        </div>
                        <div className="col-span-2 text-right text-sm">
                            {z.free_threshold > 0 ? (
                                <span className="text-charcoal inline-flex items-center gap-1 justify-end">
                                    <Gift strokeWidth={1.5} className="w-3 h-3 text-gold hidden md:inline" />
                                    desde ${z.free_threshold.toLocaleString("es-CO")}
                                </span>
                            ) : (
                                <span className="text-taupe">—</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
